import React, {useState} from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import {FiX, FiCalendar} from 'react-icons/fi';

const BookingModal = ({onClose}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-stone-900/70 backdrop-blur-sm">
      <motion.div
        initial={{opacity: 0, scale: 0.95, y: 20}}
        animate={{opacity: 1, scale: 1, y: 0}}
        className="bg-[#faf8f5] rounded-[2rem] w-full max-w-2xl shadow-2xl overflow-hidden border border-stone-200"
        style={{height: '600px'}}
      >
        <div className="bg-stone-900 px-6 py-4 flex items-center justify-between">
          <div>
            <p className="text-amber-400 text-xs font-bold uppercase tracking-widest mb-0.5">Strategy Call</p>
            <p className="text-white font-bold text-sm font-serif">Book 10 Min with Stuart</p>
          </div>
          <button onClick={onClose} className="text-stone-400 hover:text-white transition-colors p-1">
            <SafeIcon icon={FiX} className="text-lg" />
          </button>
        </div>
        <iframe
          src="https://links.myvoicelocal.com/widget/bookings/10-minute-call-with-stu"
          style={{width: '100%', height: 'calc(100% - 60px)', border: 'none'}}
          title="Book a Call with Stuart"
        />
      </motion.div>
    </div>
  );
};

export default BookingModal;